import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'

const AWSAuth = () => import('@/views/AWSAuth')
const EcoLocations = () => import(/* webpackChunkName: "ecosystem" */ '@/components/eco-locations/eco-locations')
const PaidPorts = () => import(/* webpackChunkName: "paidPorts" */ '@/components/paid-ports/paid-ports')
const ServicesBy = () => import(/* webpackChunkName: "servicesBy" */ '@/components/services-by/services-by')
const Company = () => import(/* webpackChunkName: "company" */ '@/components/company/company')
const Person = () => import(/* webpackChunkName: "person" */ '@/components/company/person')
const MapView = () => import(/* webpackChunkName: "mapView" */ '@/components/map-view/map-view')
const Service = () => import(/* webpackChunkName: "service" */ '@/components/service/service')

const LocationsPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/LocationsPage')
const CircuitsPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/CircuitsPage')
const PatchPanelsPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/PatchPanelsPage')
const IPTransitSMTPExceptionPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/IPTransitSMTPExceptionPage')
const IPTransitBlackholePage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/IPTransitBlackholePage')
const DevicesPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/DevicesPage')
const IPTransitNetworksPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/IPTransitNetworksPage')
const CrossconnectsPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/CrossconnectsPage')
const OrganisationsPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/OrganisationsPage')
const MetrosPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/MetrosPage')
const ColocationPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/ColocationPage')
const HistoryPage = () => import(/* webpackChunkName: "resources" */ '@/components/resources/HistoryPage')
const AssetChargesPage = () => import(/* webpackChunkName: "AssetChargesPage" */ '@/components/inventory/AssetChargesPage')
const SupplierRateCardsPage = () => import(/* webpackChunkName: "SupplierRateCards" */ '@/components/resources/SupplierRateCardsPage')
const VirtualMachineImagesPage = () => import(/* webpackChunkName: "VirtualMachineImages" */ '@/components/resources/VirtualMachineImagesPage')

const UsersPage = () => import(/* webpackChunkName: "user" */ '@/components/user/UsersPage')
const ActiveMembers = () => import('@/components/active-customers/active-customers')
const SearchPage = () => import('@/views/SearchPage')

const BGPConnectionPage = () => import('@/components/resources/BGPConnectionPage')

const PatchingPage = () => import(/* webpackChunkName: "PatchingPage" */ '@/components/patching/PatchingPage.vue')
const PatchingDevicePage = () => import(/* webpackChunkName: "PatchingDevicePage" */ '@/components/patching/PatchingDevicePage.vue')
const PatchingPatchPanelPage = () => import(/* webpackChunkName: "PatchingPatchPanelPage" */ '@/components/patching/PatchingPatchPanelPage.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: '/auth/authenticate',
      component: Dashboard,
    },
    {
      path: '/ecosystem/locations',
      component: EcoLocations,
      meta: {
        title: 'Locations',
      },
    },
    {
      path: '/ecosystem/paid-ports',
      component: PaidPorts,
      meta: {
        title: 'Paid Ports',
      },
    },
    {
      path: '/ecosystem/paid-ports/report/:date/:country/:key',
      component: PaidPorts,
      meta: {
        title: 'Paid Ports',
      },
    },
    {
      path: '/ecosystem/active-customers',
      component: ActiveMembers,
      meta: {
        title: 'Active Customers',
      },
    },
    {
      path: '/map',
      component: MapView,
      meta: {
        title: 'Map View',
      },
    },
    {
      path: '/users/:id?',
      component: UsersPage,
      meta: {
        title: 'Users',
      },
    },
    {
      path: '/services-by/:type/:id',
      component: ServicesBy,
      meta: {
        title: 'Services',
      },
    },
    {
      path: '/company/:id',
      component: Company,
      meta: {
        title: 'Company',
      },
    },
    {
      path: '/person/:id',
      component: Person,
      meta: {
        title: 'Company User',
      },
    },
    {
      path: '/search/:query?',
      name: 'search',
      component: SearchPage,
      meta: {
        title: 'Search',
      },
    },
    {
      path: '/service/:id',
      name: 'serviceById',
      component: Service,
      meta: {
        title: 'Service',
      },
    },
    // resource redirections
    {
      path: '/resource/:resourceName/:action?/:id?',
      redirect: '/resources/:resourceName/:action?/:id?',
    },
    {
      path: '/resources/location/:action?/:id?',
      component: LocationsPage,
      meta: {
        title: 'Locations',
        resource: 'resources/location',
        history: 'location',
      },
    },

    {
      path: '/location/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/location',
      },
    },
    {
      path: '/resources/circuit/:action?/:id?',
      alias: '/resources/carrier_circuit/:action?/:id?',
      component: CircuitsPage,
      meta: {
        title: 'Circuits',
        resource: 'resources/circuit',
        history: 'circuit',
      },
    },
    {
      path: '/circuit/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/circuit',
      },
    },
    {
      path: '/resources/patch-panel/:action?/:id?',
      component: PatchPanelsPage,
      meta: {
        title: 'Patch Panels',
        resource: 'resources/patch-panel',
        history: 'patch-panel',
      },
    },
    {
      path: '/patch-panel/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/patch-panel',
      },
    },
    {
      path: '/resources/device/:action?/:id?',
      component: DevicesPage,
      meta: {
        title: 'Devices',
        resource: 'resources/device',
        history: 'device',
      },
    },
    {
      path: '/device/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/device',
      },
    },
    {
      path: '/resources/ip-transit-network/:action?/:id?',
      component: IPTransitNetworksPage,
      meta: {
        title: 'IP Transit Networks',
        resource: 'resources/ip-transit-network',
        history: 'ip-transit-network',
      },
    },
    {
      path: '/ip-transit-network/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/ip-transit-network',
      },
    },
    {
      path: '/resources/crossconnect/:action?/:id?',
      alias: '/resources/cross_connect/:action?/:id?',
      component: CrossconnectsPage,
      meta: {
        title: 'Cross Connects',
        resource: 'resources/crossconnect',
        history: 'crossconnect',
      },
    },
    {
      path: '/crossconnect/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/crossconnect',
      },
    },
    {
      path: '/resources/organisation/:action?/:id?',
      component: OrganisationsPage,
      meta: {
        title: 'Organisations',
        resource: 'resources/organisation',
        history: 'organisation',
      },
    },
    {
      path: '/organisation/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/organisation',
      },
    },
    {
      path: '/resources/location-metro/:action?/:id?',
      component: MetrosPage,
      meta: {
        title: 'Metros',
        resource: 'resources/location-metro',
        history: 'location-metro',
      },
    },
    {
      path: '/location-metro/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/location-metro',
      },
    },
    {
      path: '/resources/colocation/:action?/:id?',
      component: ColocationPage,
      meta: {
        title: 'Colocation',
        resource: 'resources/colocation',
        history: 'colocation',
      },
    },
    {
      path: '/colocation/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/colocation',
      },
    },
    {
      path: '/resources/supplier-rate-card/:action?/:id?',
      component: SupplierRateCardsPage,
      meta: {
        title: 'Supplier Rate Card',
        resource: 'resources/supplier-rate-card',
        history: 'supplier-rate-card',
      },
    },
    {
      path: '/supplier-rate-card/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/supplier-rate-card',
      },
    },
    {
      path: '/resources/virtual-machine-image/:action?/:id?',
      component: VirtualMachineImagesPage,
      meta: {
        title: 'Virtual Machine Images',
        resource: 'resources/virtual-machine-image',
        history: 'virtual-machine-image',
      },
    },
    {
      path: '/virtual-machine-image/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/virtual-machine-image',
      },
    },
    {
      path: '/inventory/asset-charges/:action?/:id?',
      component: AssetChargesPage,
      meta: {
        title: 'Asset Charges',
        resource: 'inventory/asset-charges',
      },
    },
    {
      path: '/resources/bgp-connection/:action?/:id?',
      alias: '/resources/bgp_connection/:action?/:id?',
      component: BGPConnectionPage,
      meta: {
        title: 'BGP Connection',
        resource: 'resources/bgp-connection',
        history: 'bgp-connection',
      },
    },
    {
      path: '/bgp-connection/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/bgp-connection',
      },
    },
    {
      path: '/resources/ip-transit-smtp-exception/:action?/:id?',
      component: IPTransitSMTPExceptionPage,
      meta: {
        title: 'SMTP Exceptions',
        resource: 'resources/ip-transit-smtp-exception',
        history: 'ip-transit-smtp-exception',
      },
    },
    {
      path: '/ip-transit-smtp-exception/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/ip-transit-smtp-exception',
      },
    },
    {
      path: '/resources/ip-transit-blackhole/:action?/:id?',
      component: IPTransitBlackholePage,
      meta: {
        title: 'IP Transit Blackholes',
        resource: 'resources/ip-transit-blackhole',
        history: 'ip-transit-blackhole',
      },
    },
    {
      path: '/ip-transit-blackhole/:id/history',
      component: HistoryPage,
      meta: {
        title: 'History',
        resource: 'resources/ip-transit-blackhole',
      },
    },
    {
      path: '/patching',
      name: 'patching',
      component: PatchingPage,
      meta: {
        title: 'Patching',
      },
    },
    {
      path: '/patching/device/:id',
      name: 'patchingDevice',
      component: PatchingDevicePage,
      meta: {
        title: 'Patching - Device',
      },
    },
    {
      path: '/patching/patch-panel/:id',
      name: 'patchingPatchPanel',
      component: PatchingPatchPanelPage,
      meta: {
        title: 'Patching - Patch Panel',
      },
    },
    {
      path: '/awslogin',
      component: AWSAuth,
    },
    {
      path: '/awslogout',
      component: AWSAuth,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const pageTitle = to.meta.title || ''
  document.title = `${import.meta.env.VITE_APP_TITLE} - ${pageTitle}`
  next()
})

export default router
